import React, {useEffect} from 'react';
import Checkout from "../checkout/Checkout.js";
import {logGAEvent} from "../firebaseConfig/firebaseConfig";

function Cart() {
    useEffect(() => {
        logGAEvent('begin_checkout', {});
    }, []);

    return (
        <div>
            <Checkout/>
        </div>
    );
}

export default Cart;